import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import Config from '../config/config';
import ApiClient from '../ApiClient';

/**
 * Hook to handle slot-based API endpoint routing for web app.
 * Reads the 'use-test-slot' LaunchDarkly flag and updates ApiClient endpoint accordingly.
 *
 * When flag is "test" → routes to test endpoints (for targeted test users)
 * When flag is "live" (default) → routes to live endpoints (for everyone else)
 */
export const useSlotConfig = (): void => {
  const flags = useFlags();
  const slot = flags['use-test-slot'] as string | undefined || 'live';

  useEffect(() => {
    const testApiBaseUrl = Config.getTestApiBaseUrl?.();

    if (slot === 'test' && testApiBaseUrl) {
      // Update ApiClient to use test endpoint
      ApiClient.getInstance().setBaseUrl(testApiBaseUrl);
    } else {
      // Reset to live endpoint (use default from config)
      ApiClient.getInstance().setBaseUrl(Config.getApiBaseUrl());
    }
  }, [slot]);
};
